import React, { Fragment, useEffect, useState } from "react";
import DataTable from "../../../Common/Components/DataTable";
import {
  GetData,
  DeleteData,
  DataSearch,
  EditData,
  ToggleBtn,
  Deactvie,
  createRefund,
  deleteRefund,
  getRefund,
} from "./Components/Services";
import Loading from "../../../Common/Components/Loading";
import { Helmet } from "react-helmet";
import { useNavigate, useLocation } from "react-router";
import CustomModal from "../../../Common/Components/Modal/CustomModal";
import { FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import Calender from "../../../Common/Components/Calender";
import { data } from "jquery";
import { useRef } from "react";
import { BsCaretLeft, BsTrash } from "react-icons/bs";

function List() {
  const initialState = {
    loading: false,
    filter: null,
    data: {
      data: null,
      current_page: null,
    },
    modal: false,
    modelAreYouSure: false,
  };
  const [filter, setFilter] = useState({});

  const location = useLocation();
  const item = location;
  const [state, setstate] = useState(initialState);
  useEffect(() => {
    if (item) {
      HandlerSearch(item.state);
    }
  }, []);
  const [filters, setfilters] = useState({
    type_sort: "created",
  });

  const Handler = (pageNumber = 1, limit, filters) => {
    setstate({ ...state, loading: true });
    GetData(pageNumber, limit, filters).then(result => {
      setstate({
        loading: false,
        data: result,
      });
    });
  };

  const HandlerDelete = data => {
    setstate({ ...state, loading: true });
    DeleteData(data).then(() => {
      GetData().then(result => {
        setstate({
          loading: false,
          data: result,
        });
      });
    });
  };
  const HandlerSearch = data => {
    setstate({ ...state, loading: true });
    DataSearch({ name: data }).then(data => {
      setstate({
        loading: false,
        data: data,
      });
    });
  };
  const ToggleStatus = data => {
    setstate({ ...state, loading: true });
    ToggleBtn({
      item_id: state.modal,
      ...data,
    }).then(async () => {
      setstate({ ...state, loading: false, modal: false });
      await Handler(1, 15, filters);
    });
  };
  const DeactiveItem = () => {
    setstate({ ...state, loading: true });
    Deactvie({
      item_id: state.modal,
      deactive: true,
    }).then(async () => {
      setstate({ ...state, loading: false, modal: false });
      await Handler(1, 15, filters);
    });
  };

  const navigate = useNavigate();
  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | لیست مجموعه ها</title>
      </Helmet>

      <DataTable
        filter={true}
        loading={state.loading}
        heads={[
          {
            title: "شماره ثبت",
            key: "registration_number",
          },

          {
            title: "عنوان",
            key: "name",
          },
          {
            title: "اخرین بروز رسانی",
            key: "updated_at",
            type: "date",
            timetype: "date-time",
          },

          {
            title: "تاریخ ایجاد",
            key: "created_at",
            type: "date",
            timetype: "date-time",
          },
        ]}
        textEmpty="ابتدا نوع مرتب سازی را انتخاب کنید"
        list={state.data.data}
        data={state.data}
        function={Handler}
        search={HandlerSearch}
        currentPage={state.data.current_page}
        header=" لیست مجموعه ها"
        textbtn="ایجاد مجموعه"
        linkbtn="/Admin/Item/CreateBySteps"
        links={[
          {
            function: selected => {
              HandlerDelete({ item_id: selected });
            },
            color: "danger",
            size: "col",
            html: "حذف",
            multi: true,
            type: "delete",
          },

          {
            function: selected => {
              setstate({ ...state, modal: selected[0] });
            },
            color: "info",
            size: "col",
            html: "ویرایش",
            type: "edit",
            main: true,
          },
          {
            size: "col-4",
            selected: true,
            typeLink: "div",
            html: (
              <FormControl fullWidth size="small">
                <InputLabel id="demo-multiple-name-label">
                  مرتب شدن بر اساس
                </InputLabel>
                <Select
                  labelId="demo-multiple-name-label"
                  onChange={e => {
                    Handler(null, null, {
                      ...filters,
                      type_sort: e.target.value,
                    });
                  }}
                  label={"مرتب شدن بر اساس"}
                >
                  <MenuItem value="0">انتخاب نوع</MenuItem>

                  <MenuItem value={"created"}>تاریخ ایجاد</MenuItem>
                  <MenuItem value={"updated"}>تاریخ به روزرسانی</MenuItem>
                  <MenuItem value={"registration"}>شماره ثبت</MenuItem>
                </Select>
              </FormControl>
            ),
          },
        ]}
      />
      <CustomModal
        show={state.modal}
        handleClose={() => {
          setstate({ ...state, modal: false });
        }}
        header={"انتخاب نوع ویرایش"}
      >
        <Settings
          value={
            state.data.data &&
            state.data.data.filter(item => item.id === state.modal)[0]
          }
          selected={state.modal}
          submit={ToggleStatus}
          state={state}
          setstate={setstate}
        />
      </CustomModal>
      <CustomModal
        show={state.modelAreYouSure}
        handleClose={() => {
          setstate({ ...state, modelAreYouSure: false });
        }}
        header={"آیا مطمئن هستید ؟؟؟؟؟"}
      >
        <AreYouSure
          value={null}
          state={state}
          setstate={setstate}
          submit={DeactiveItem}
        />
      </CustomModal>
    </Fragment>
  );
}

const Settings = ({ value, selected, submit, state, setstate }) => {
  const [step, setStep] = useState(1);
  const navigate = useNavigate();

  const conditionalRendering = () => {
    switch (value && value.timetable) {
      case "deactive":
        return (
          <div className="d-flex justify-content-between" style={{ flex: 1 }}>
            <button
              className="btn btn-primary text-white"
              onClick={() => {
                navigate(`/Admin/Item/Edit/${value.slug}`);
              }}
            >
              ویرایش جزییات مجموعه
            </button>

            <button
              className="btn btn-primary text-white"
              onClick={() => {
                navigate(`/Admin/Item/ItemActive/${selected}`);
              }}
            >
              ایجاد جدول زمان بندی
            </button>
            <button
              className="btn btn-primary text-white"
              onClick={() => {
                navigate(`/Admin/Item/SubmitUsers/${selected}`);
              }}
            >
              افزودن مدیر
            </button>
          </div>
        );
      case "active":
        switch (step) {
          case "refund":
            return (
              <Refund value={value} />
            )
          case "add_contract_period":
            return (
              <div>
                <Calender
                  label={"تاریخ اتمام قرارداد جدید"}
                  form={state}
                  setForm={setstate}
                  keyData="new_date_end"
                />
                <button
                  disabled={!state.new_date_end || state.loading}
                  className="btn btn-primary mt-4"
                  onClick={() => {
                    submit({
                      item_id: value.id,
                      action: "add_contract_period",
                      new_date_end: state.new_date_end,
                    });
                  }}
                >
                  {state.loading ? "در حال بررسی" : "ثبت"}
                </button>
              </div>
            );
          case "setexperid":
            return (
              <div>
                <p>آیا مطمئن هستید آقای شوروزی جان ؟‌</p>
                <button
                  disabled={state.loading}
                  className="btn btn-primary mt-4"
                  onClick={() => {
                    submit({
                      item_id: value.id,
                      action: "setexperid",
                    });
                  }}
                >
                  {state.loading ? "در حال بررسی" : "منقضی کردن"}
                </button>
              </div>
            );
          default:
            break;
        }
        return (
          <div className="d-flex justify-content-between flex-wrap" style={{ flex: 1 }}>
            <button
              className="btn btn-primary text-white d-flex"
              onClick={() => {
                navigate(`/Admin/Item/Edit/${value.slug}`);
              }}
            >
              ویرایش جزییات مجموعه
            </button>

            <button
              className="btn btn-primary text-white"
              onClick={() => {
                setStep("add_contract_period");
              }}
            >
              تمدید قرارداد
            </button>

            <button
              className="btn btn-primary text-white"
              onClick={() => {
                setStep("setexperid");
              }}
            >
              منقضی کردن قرارداد
            </button>
            <button
              className="btn btn-primary text-white"
              onClick={() => {
                navigate(`/Admin/Item/EditTimeTable/${value.id}`, {
                  data: value,
                });
              }}
            >
              ویرایش زمان بندی
            </button>
            <button
              className="btn btn-primary text-white"
              onClick={() => {
                navigate(`/Admin/Item/SubmitUsers/${selected}`);
              }}
            >
              افزودن مدیر
            </button>

            <button className="btn btn-primary text-white mx-auto mt-3"
              onClick={() => {
                setStep("refund");
              }}
            >
              تنظیمات استرداد
            </button>

          </div>
        );
      case "experid":
        switch (step) {
          case "add_contract_period":
            return (
              <div>
                <Calender
                  label={"تاریخ اتمام قرارداد جدید"}
                  form={state}
                  setForm={setstate}
                  keyData="new_date_end"
                />
                <button
                  disabled={!state.new_date_end || state.loading}
                  className="btn btn-primary mt-4"
                  onClick={() => {
                    submit({
                      item_id: value.id,
                      action: "add_contract_period",
                      new_date_end: state.new_date_end,
                    });
                  }}
                >
                  {state.loading ? "در حال بررسی" : "ثبت"}
                </button>
              </div>
            );
            break;

          default:
            break;
        }
        return (
          <div className="d-flex justify-content-between" style={{ flex: 1 }}>
            <button className="btn btn-primary text-white"
              onClick={() => {
                navigate(`/Admin/Item/Edit/${value.slug}`);
              }}
            >
              ویرایش جزییات مجموعه
            </button>

            <button className="btn btn-primary text-white"
              onClick={() => {
                navigate(`/Admin/Item/ItemActive/${selected}-newtimetable`, {
                  data: value,
                });
              }}>
              جدول زمان بندی جدید
            </button>

            <button className="btn btn-primary text-white"
              onClick={() => {
                setStep("add_contract_period");
              }}
            >
              تمدید قرارداد فعلی
            </button>
            <button className="btn btn-primary text-white"
              onClick={() => {
                navigate(`/Admin/Item/SubmitUsers/${selected}`);
              }}
            >
              افزودن مدیر
            </button>
          </div>
        );
      default:
        return (
          <div>
            <h6>نوع زمان بندی مجموعه مشخص نیس</h6>
          </div>
        );
        break;
    }
  };
  return <div className="d-flex">{conditionalRendering()}</div>;
};
const AreYouSure = ({ setstate, state, submit }) => {
  return (
    <div>
      <h6>با غیر فعال کردن مجموعه اطلاعات تایم بندی پاک میشود.</h6>
      <button className="btn btn-success text-white" onClick={submit}>
        بله
      </button>
      <button
        className="btn btn-primary text-white mr-3"
        onClick={() =>
          setstate({ ...state, modelAreYouSure: false, modal: false })
        }
      >
        خیر
      </button>
    </div>
  );
};

const Refund = ({ value }) => {
  const [refundData, setRefundData] = useState({
    timeData: null,
    percentData: null,
    refundList: null,
    loading: true
  });

  useEffect(() => {
    callGetRefund();
  }, [])

  const callGetRefund = () => {
    getRefund({ item_id: value.id }).then(data => {
      setRefundData({ ...refundData, loading: false, refundList: data })
    });
  }
  const callDeleteRefund = (id) => {
    let isDelete = window.confirm("آیا حذف شود ؟")
    if (isDelete) {
      deleteRefund({
        refund_setting_id: id
      }).then(item => {
        callGetRefund();
      })
    }
  }
  const callCreateRefund = () => {
    createRefund({
      item_id: value.id,
      remaining_time: refundData.timeData,
      percentage: refundData.percentData
    }).then(item => {
      callGetRefund();
    })
  }
  return (
    <div className="row w-100">
      <div className="col-6">
        <h5 className="text-center pb-2 border-bottom">ثبت استرداد </h5>
        <div className={`mt-2 `}>
          <TextField size="small" label="ساعت باقی مانده" placeholder="مثال : 2" className="w-100"
            onChange={(e) => setRefundData({ ...refundData, timeData: e.target.value })} />
        </div>
        <div className={`mt-3`}>
          <TextField size="small" label="درصد کسر" placeholder="مثال : 5" className="w-100"
            onChange={(e) => setRefundData({ ...refundData, percentData: e.target.value })} />
        </div>
        <button className="btn btn-primary mt-3 justify-content-center w-100"
          onClick={callCreateRefund}>
          ثبت
        </button>
      </div>

      <div className="col-6">
        <h5 className="text-center pb-2 border-bottom">لیست استرداد ها</h5>

        <div className="px-3">
          {refundData.loading
            ?
            <p>در حال بارگذاری ...</p>
            : refundData.refundList.length > 0 ?
              refundData.refundList.map(item => {
                return <p key={item.id} className="bg-light border shadow-sm rounded mb-2 d-flex align-items-center">
                  <BsCaretLeft />

                  <span className="mx-2">
                    ساعت باقی مانده :
                    <span className="mx-1">
                      {item.remaining_time}
                    </span>
                  </span>

                  <span className="">
                    درصد کسر :
                    <span className="mx-1">
                      {item.percentage} %
                    </span>
                  </span>
                  <span style={{ cursor: "pointer", marginRight: "auto", marginLeft: "5px" }}>
                    <BsTrash className="text-danger" onClick={() => callDeleteRefund(item.id)} />
                  </span>

                </p>
              })
              : <p className="text-center">هیچ استردادی ثبت نشده است</p>
          }
        </div>

      </div>

    </div>
  )
}
export default List;
